import { Component, OnInit, inject } from '@angular/core';
import { CdsOption } from '@cds/ng-core/configuration';
import { LanguageChangeService } from 'src/app/shared/language-change.service';
import { createCopyrightYear } from 'src/app/utils/dateUtils';
import { environment } from 'src/environments/environment';
import { CdsIconModule } from '@cds/ng-web-components/icon';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { CdsNavigationModule } from '@cds/ng-web-components/navigation';
import { RouterOutlet } from '@angular/router';
import { CdsLanguageModule } from '@cds/ng-core/lang';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss'],
  imports: [CdsIconModule, MatMenuTrigger, CdsNavigationModule, RouterOutlet, MatMenu, MatMenuItem, CdsLanguageModule],
})
export class AuthLayoutComponent implements OnInit {
  private languageChangeService = inject(LanguageChangeService);

  languages: CdsOption[] = environment.languageList;
  copyright = createCopyrightYear();
  cdsIconConfig = { color: '#FFFFFF', size: 'sm' };
  isOpen = false;
  ngOnInit(): void {}
  selectedValue = '';

  changeLang(lang: string) {
    this.languageChangeService.setLang(lang);
    this.selectedValue = lang;
    this.isOpen = false;
  }
}
